// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG, PRODUCTION } from "common/config";
import { COMMON_JS } from "common/scripts";

export const GEO_APIs = {
  // Adding/Editing Country
  getGoogleResult: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/4NJ7QM05BSX8WYI8",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  manageCountry: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/647E9674G44439LY",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Country details
  getCountries: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/110T5189V47573RB",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing Currency
  manageCurrency: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/134R9833Y31419LF",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get Currency details
  getCurrencies: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/930I2442Q95272NN",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing state
  manageState: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/260S2228L48634XZ",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get states details
  getStates: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/875E8139L74106VG",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing region
  manageRegion: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/560G8274M58845SD",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get regions details
  getRegions: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/299K9938V88156VM",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing area
  manageCity: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/481J5571G41479PT",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get areas details
  getCities: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/775C4406C17657YN",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Adding/Editing area
  manageArea: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/ge/v1/812D2484K56185PV",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get areas details
  getAreas: async (args = {}) => {
    let apiUrl = "/ge/v1/209E7002A15449QL";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.0.109:8004/ge/v1/209E7002A15449QL";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      PRODUCTION === "false"
    );
    return response;
  },

  // Adding/Editing areabeat
  manageAreaBeat: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/v1/geography/areabeat",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get areabeats details
  getAreaBeat: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/v1/geography/areabeats",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
};
